import React from 'react';
import PropTypes from 'prop-types';
import './FactRow.css';

/**
 * KeyValueList — label / value rows (order summaries, totals): `rows` with a
 * `variant` per row ('discount' = the success tone), and an optional `total`
 * row set apart by a hairline.
 *
 * `size="small"`: compact breakdown rows (P.Regular, gray-7, a DS Price value
 * takes the row's tone) with small-m above and below each row; the total keeps
 * H5 / gray-10. The hairline colour is the `--kv-divider-color` hook (gray-1;
 * a card on gray-025 sets gray-0).
 */
const KeyValueList = ({ rows = [], total, dividers = false, size = 'regular', className = '' }) => (
  <dl className={['ds-kv', dividers && 'ds-kv--dividers', size === 'small' && 'ds-kv--small', className].filter(Boolean).join(' ')}>
    {rows.map(({ label, value, variant = 'default' }, index) => (
      <div key={typeof label === 'string' ? label : index} className={`ds-kv__row ds-kv__row--${variant} typo-body`}>
        <dt className="ds-kv__label">{label}</dt>
        <dd className="ds-kv__value">{value}</dd>
      </div>
    ))}
    {total && (
      <div className="ds-kv__row ds-kv__row--total typo-h5">
        <dt className="ds-kv__label">{total.label}</dt>
        <dd className="ds-kv__value">{total.value}</dd>
      </div>
    )}
  </dl>
);

const rowShape = PropTypes.shape({
  label: PropTypes.node.isRequired,
  value: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['default', 'discount', 'muted']),
});

KeyValueList.propTypes = {
  rows: PropTypes.arrayOf(rowShape),
  /** Final row, set apart by a hairline and the H5 weight */
  total: PropTypes.shape({ label: PropTypes.node.isRequired, value: PropTypes.node.isRequired }),
  /** Hairline between every row */
  dividers: PropTypes.bool,
  /** 'small' = compact breakdown rows (gray-7, small-m row padding, no gap) */
  size: PropTypes.oneOf(['regular', 'small']),
  className: PropTypes.string,
};

export default KeyValueList;
